import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../../assets/css/Header.css'
import logo from '../../assets/images/logo.png';
import profile_pic from '../../assets/images/user_profile_pic.png';
import { useDispatch, useSelector } from 'react-redux';
import { getSiteSettings, TickersGet } from '../../Redux/Auth/Auth_Action';
import { toast } from 'react-toastify';
import SwipHeader from './SwipHeader';
import PersonIcon from '@mui/icons-material/Person';


const Header = () => {
    const reduxState = useSelector((state) => state);
    const [login, setLogin] = useState(true);
    const [marquee, setMarquee] = useState(undefined);
    
    let navigate = useNavigate();
    let pathname = window.location.pathname;
    const dispatch = useDispatch();

    const getSiteSettingsApi=()=>{
        dispatch(getSiteSettings())
        .then((res)=>{
            localStorage.setItem('siteSettings', JSON.stringify(res?.data?.response?.data));
            // console.log(res?.data?.response?.data,'getSiteSettingsApigetSiteSettingsApigetSiteSettingsApi');
        })
        .catch((error)=>{
            console.log(error,"getSiteSettingsApigetSiteSettingsApigetSiteSettingsApi");
        })
    }

    const GetTicker = () => {
        dispatch(TickersGet())
            .then((res) => {
                // console.log("res", res.data.response.data);
                setTimeout(() => {
                    setMarquee(res?.data?.response?.data);
                }, 1500);
            })
            .catch((e) => {
                toast.error("Network Error");
                console.log("error", e)
            })
    }

    // console.log(marquee.marqueeData);

    useEffect(() => {
        GetTicker();
        getSiteSettingsApi();
    }, [0]);

    const HeaderLinks = [
        { name: "HOME", link: "/" },
        { name: "ABOUT ME", link: "/aboutus" },
        { name: "TIPS", link: "/tips" },
        { name: "PACKAGES", link: "/packages" },
        { name: "BLOGS", link: "/blogs" },
        { name: "CONTACT", link: "/contactus" },
        { name: "PODCAST", link: "/podcast" },
    ];

    return (
        <div className='header'>
            <div className='header-top-pink'>
                <div className='container-fluid'>
                    <div className='d-flex justify-space-hdr-top'>
                        {(marquee) ?
                            <marquee loop="infinite">
                                {
                                    marquee?.map((item, index) => {
                                        return (
                                            <span key={index} className=''><b>{item?.title}</b>  <span className=''><span className=''>:</span> {item?.description}</span> </span>
                                        )
                                    })
                                }
                            </marquee>
                            :
                            <></>
                        }

                    </div>
                </div>
            </div>
            <div className='header-main-content py-4'>
                <div className='container'>
                    <div className='logo-content-full'>
                        <div>
                            <Link to='/'>
                                <img src={logo} alt="header-logo" className='header-logo' />
                            </Link>
                        </div>
                        <div className='d-flex'>
                            {HeaderLinks.map((item, index) => {
                                return (
                                    <Link key={index} className='pos-rel textdec-none' to={`${item.link}`}>
                                        <span className={`${(pathname === `${item.link}`) ?
                                            "mx-4auto f-mon-reg f-16 text-white link_header_active textdec-none" :
                                            " mx-4auto f-mon-reg f-16 text-white link_header link_header textdec-none"}`}>
                                            {item.name}</span>
                                    </Link>
                                )
                            })}
                        </div>
                        <div>
                            {
                                (reduxState.Auth.token) ?
                                    <>
                                        <div className='d-flex align-item-center'>
                                            <span className='f-mon-semibold text-white f-16 mr-3'>
                                                <span className='f-mon-light mr-2'>Hi!
                                                </span>
                                                {`${reduxState.Auth.user.first_name}`}
                                                {/* ${reduxState.Auth.user.last_name} */}
                                            </span>
                                            {(reduxState?.Auth?.user?.profile_picture)
                                                ?
                                                <span>
                                                    <img onClick={() => { navigate("/profile") }} className="profile_img_header"
                                                        src={reduxState?.Auth?.user?.profile_picture}
                                                    />
                                                </span>
                                                :
                                                <span>
                                                    <img onClick={() => { navigate("/profile") }} className="profile_img_header"
                                                        src={profile_pic}
                                                    />
                                                </span>
                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <button
                                            onClick={() => { navigate("/signup") }}
                                            className='btn btn-light f-16 f-mon-reg btn-join-now '>
                                            JOIN NOW
                                        </button>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className='header-small'>
                <div className='bg-red-hdr'>
                    <div className=''>

                        <div className='d-flex align-center'>
                            <Link to="/">
                                <img onClick={() => { navigate('/') }} className=' img_respon py-2 px-0' src={logo} alt='logo' />
                            </Link>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='align-center'>
                            {(reduxState.Auth.token) ?
                                <Link className='f-pop-reg home_link mr-2 ico_pos-rel_headd' to="/profile">
                                    <img className="profile_img_header mt-2"
                                        src={((reduxState?.Auth?.user?.profile_picture) === null) ? profile_pic : reduxState?.Auth?.user?.profile_picture} />
                                </Link>
                                :
                                <div>
                                    {
                                        (reduxState.Auth.token) ?
                                            <>
                                                <div className='d-flex align-item-center'>
                                                    <span className='f-mon-semibold text-white f-16 mr-3'>
                                                        <span className='f-mon-light mr-2'>Hi!
                                                        </span>
                                                        {`${reduxState.Auth.user.first_name}`}
                                                    </span>
                                                    <span>
                                                        <img onClick={() => { navigate("/profile") }} className="profile_img_header"
                                                            src={reduxState?.Auth?.user?.profile_picture}
                                                        />
                                                    </span>
                                                </div>
                                            </>
                                            :
                                            <>
                                                <button
                                                    onClick={() => { navigate("/signup") }}
                                                    className='btn btn-light f-16 f-mon-reg btn-swip-hhdr '>
                                                    JOIN NOW
                                                </button>
                                            </>
                                    }
                                </div>
                                // <Link className='f-pop-reg home_link mr-2 ico_pos-rel_headd' to="/signin">
                                //     <PersonIcon className='align-self-center text-white mt-2 me-4' />
                                // </Link>
                            }

                        </div>
                        <div className='header-small'>
                            <SwipHeader headerLinks={HeaderLinks} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Header;